import { CalendarView } from "PFApp/booking/types";
import { UseFiltersReturn } from "PFApp/use_filtered_collection/use_filters";
import { OrderStorage } from "PFApp/use_filtered_collection/use_storage_order";
import { Filters, Value } from "PFTypes";

import { useFiltersWithPostAction } from "./use_filters_with_post_action";
import { useOrderWithPostActions } from "./use_order_with_post_actions";

const DEFAULT_ORDER = { name: ["activity.saas_created_at"], text: "Latest first", direction: "desc" };
export const DEFAULT_FILTERS_BY_VIEW: Partial<Record<CalendarView, Filters<Value>>> = {
  [CalendarView.EngagementsAndAuditEngagements]: {
    children: {
      fields: {
        template_key: ["role", "audit_role"]
      }
    },
    fields: {
      template_key: ["engagement", "audit_engagement"]
    }
  },
  [CalendarView.RolesAndAuditRoles]: {
    fields: {
      template_key: ["role", "audit_role"]
    }
  }
};

const VERSION = 4;
const getStoragePrefix = (view: CalendarView) => `booking_module_overview_projects_${view}-v${VERSION}`;

interface UseProjectsFiltersOrder {
  postChangeAction: VoidFunction;
}
interface UseProjectsFiltersOrderReturn {
  [CalendarView.EngagementsAndAuditEngagements]: {
    filters: UseFiltersReturn;
    order: OrderStorage;
  };
  [CalendarView.RolesAndAuditRoles]: {
    filters: UseFiltersReturn;
    order: OrderStorage;
  };
}

export const useProjectsFiltersOrder = ({
  postChangeAction
}: UseProjectsFiltersOrder): UseProjectsFiltersOrderReturn => {
  const engagementFiltersState = useFiltersWithPostAction({
    storagePrefix: getStoragePrefix(CalendarView.EngagementsAndAuditEngagements),
    defaultValue: DEFAULT_FILTERS_BY_VIEW[CalendarView.EngagementsAndAuditEngagements],
    postChangeAction
  });

  const roleFiltersState = useFiltersWithPostAction({
    storagePrefix: getStoragePrefix(CalendarView.RolesAndAuditRoles),
    defaultValue: DEFAULT_FILTERS_BY_VIEW[CalendarView.RolesAndAuditRoles],
    postChangeAction
  });

  const engagementOrderState = useOrderWithPostActions({
    storagePrefix: getStoragePrefix(CalendarView.EngagementsAndAuditEngagements),
    defaultValue: DEFAULT_ORDER,
    postChangeAction
  });

  const roleOrderState = useOrderWithPostActions({
    storagePrefix: getStoragePrefix(CalendarView.RolesAndAuditRoles),
    defaultValue: DEFAULT_ORDER,
    postChangeAction
  });

  return {
    [CalendarView.EngagementsAndAuditEngagements]: {
      filters: engagementFiltersState,
      order: engagementOrderState
    },
    [CalendarView.RolesAndAuditRoles]: {
      filters: roleFiltersState,
      order: roleOrderState
    }
  };
};
